import React from "react";
import { Section } from "@vild/site-ui";

export const Docs: React.FC = () => {
  React.useEffect(() => {
    // In production, docs live at /docs (docs site). In dev, this is still fine.
    window.location.href = "https://vild.ai/docs";
  }, []);

  return (
    <Section className="text-center py-40">
      <h1 className="text-2xl font-bold mb-4">Redirecting to Documentation...</h1>
      <p className="text-zinc-500">
        If you are not redirected automatically,{" "}
        <a href="https://vild.ai/docs" className="text-white underline">
          click here
        </a>
        .
      </p>
    </Section>
  );
};

